const getScreenType = (config) => (windowInnerWidth) => {
    if (config.mobile && windowInnerWidth <= config.mobile) {
        return 'mobile';
    }
    else if (config.tablet && windowInnerWidth <= config.tablet) {
        return 'tablet';
    }
    else {
        return 'computer';
    }
};
export default getScreenType;
//# sourceMappingURL=getScreenType.js.map